/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-10-26 14:23:45
 * @LastEditors: huangfuchunmei
 * @message: 邮件回访
 * @url: www.picoxr.com/cn/support/contact-support
 */
import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { Notification } from '@arco-design/web-react';
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import SubmitForm from "./components/Form";
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'

const ContactSupport = (props: any) => {
  const { ctry, words, data } = props.data;

  const [loading, setLoading] = useState(false)
  const submitformRef = useRef<any>();

  // 生成hreflang
  const renderHrefLang = () => {
    return (
        COUNTRY_LIST.map(item => (
            <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/contact-support`} />
        ))
    )
  }

  // 邮箱回访
  const submit = (values: Record<string,any>) => {
    request.post(`${DOMAIN_API}/o/email/sendMail`, values, {
        headers: {
          "Content-Type" : "multipart/form-data",
        }
    })
    .then(res => {
      Notification.success({
        title: '',
        content: words.blog_subscribe_success,
      })
      submitformRef.current.resetForm()
      submitformRef.current.changeVerificationCode()
      setLoading(false)
    })
    .catch(err => {
      console.log(err)
      Notification.error({
        title: '',
        content: words[err?.data?.messageInfo] || err.msg
      })
      setLoading(false)
      submitformRef.current.changeVerificationCode()
    })
  }

  return (
      <div>
        <Helmet>
          <title>{words.support_email_us_seo_title}</title>
          <meta name="description" content={words.support_email_us_seo__description} />
          <meta name="keywords" content={words.support_email_us_seo__keywods} />
          <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/contact-support`} />
          {renderHrefLang()}
        </Helmet>
        <Header ctry={ctry} words={words} />
        <main className={styles['contact-wrap']}>
          <div className={styles['contact-content-wrap']}>
            <h1>
              {words?.support_email_us_title}
              {/* Email Us */}
            </h1>
            {/* 表单 */}
            <SubmitForm
              ref={submitformRef}
              ctry={ctry}
              words={words}
              data={data}
              loading={loading}
              submit={submit}
              setLoading={setLoading} />
          </div>
        </main>
        <Footer />
      </div>
  );
};
function getCode() {
  return new Promise((resolve, reject) => {
    request.get(`${DOMAIN_API}/o/email/getDetail`)
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  });
}
ContactSupport.getInitialProps = () => {
  return getCode()
};
export default ContactSupport;
